// JobCardProfileService.tsx
import { useInfiniteQuery } from '@tanstack/react-query';
import { JobCardProfileService } from '../../core/services';
import { PageSize } from '../../type';

export const useGetJobCardService = (initialParams: PageSize) => {
  const { data, isLoading, error, refetch, fetchNextPage, hasNextPage, isFetchingNextPage, isFetching } =
    useInfiniteQuery({
      queryKey: ['get-jobcards-data'],
      queryFn: async ({ pageParam }) => {
        return JobCardProfileService.getJobCard({
          page: initialParams.pageNumber ?? pageParam,
          size: initialParams.size,
          jobCardNo: initialParams.jobCardNo,
          stationId: initialParams.stationId,
          vehiclePlate: initialParams.vehiclePlate,
          vehicleVin: initialParams.vehicleVin,
          status: initialParams.status,
          start: initialParams.start,
          end: initialParams.end,
          vehicleId: initialParams.vehicleId,
        });
      },
      initialPageParam: 1,
      getNextPageParam: (res) => (!res?.last ? res?.number + 1 : undefined),
      enabled: false,
      retry: 1,
      retryDelay: 36000000,
    });
  const isDataFetching = isFetching || isFetchingNextPage;

  return {
    data,
    isLoading,
    error,
    refetch,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isFetching,
    isDataFetching,
  };
};

export const useGetEstimatesService = (initialParams: PageSize) => {
  const { data, isLoading, error, refetch, fetchNextPage, hasNextPage, isFetchingNextPage, isFetching } =
    useInfiniteQuery({
      queryKey: ['get-estimates-data'],
      queryFn: async ({ pageParam }) => {
        return JobCardProfileService.getEstimates({
          page: initialParams.pageNumber ?? pageParam,
          size: initialParams.size,
          estimateNo: initialParams.estimateNo,
          stationId: initialParams.stationId,
          vehiclePlate: initialParams.vehiclePlate,
          vehicleVin: initialParams.vehicleVin,
          status: initialParams.status,
          start: initialParams.start,
          end: initialParams.end,
        });
      },
      initialPageParam: 1,
      getNextPageParam: (res) => (!res?.last ? res?.number + 1 : undefined),
      enabled: false,
      retry: 1,
      retryDelay: 36000000,
    });
  const isDataFetching = isFetching || isFetchingNextPage;

  return {
    data,
    isLoading,
    error,
    refetch,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isFetching,
    isDataFetching,
  };
};
